import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { injectReportsTranslations } from '@core/reports-contracts';
import {
  DetailsBreadcrumbsParams,
  DetailsBreadcrumbsService,
  ReportsComponentTileFilterBreadcrumbSync,
} from '@core/reports-types';

@Injectable()
export class DetailsGenericBreadcrumbsService implements DetailsBreadcrumbsService {
  private i18n = inject(I18nService);
  private reportsTranslations = injectReportsTranslations();

  public getBreadcrumbs({
    breadcrumbsSettings,
    dimensions,
  }: DetailsBreadcrumbsParams): ReportsComponentTileFilterBreadcrumbSync[] {
    const breadcrumbs: ReportsComponentTileFilterBreadcrumbSync[] = [];

    if (breadcrumbsSettings.primaryGroup) {
      const primaryGroup = this.reportsTranslations.translateGroup(
        breadcrumbsSettings.primaryGroup,
      );

      breadcrumbs.push({
        simple: false,
        translatedGroup: primaryGroup,
        translatedValues: [{ label: dimensions.primary.name }],
        hasOverwrites: false,
        invalid: false,
      });
    }

    if (breadcrumbsSettings.secondaryGroup) {
      const secondaryGroup = this.reportsTranslations.translateGroup(
        breadcrumbsSettings.secondaryGroup,
      );

      const label =
        dimensions.secondary.length > 1
          ? this.i18n.translate('tlr.group_name.other')
          : dimensions.secondary[0].name;

      breadcrumbs.push({
        simple: false,
        translatedGroup: secondaryGroup,
        translatedValues: [{ label }],
        hasOverwrites: false,
        invalid: false,
      });
    }

    return breadcrumbs;
  }
}
